// Paso entre la fila de la tabla "temporadas" (panel) y el tipo Temporada que usa el sitio.
import type { Decoracion, Temporada, TipoTemporada } from "@/content/temporadas";

const dia = (x: unknown) => String(x).slice(0, 10);

export function aTemporada(f: Record<string, unknown>): Temporada & { id: string } {
  const s = (k: string) => String(f[k] ?? "");
  return {
    id: String(f.id), clave: s("clave"), nombre: { es: s("nombre"), en: s("nombreEn") || s("nombre") }, tipo: (s("tipo") || "local") as TipoTemporada,
    inicio: dia(f.inicio), fin: dia(f.fin), mensaje: { es: s("mensaje"), en: s("mensajeEn") || s("mensaje") },
    boton: { es: s("botonTexto"), en: s("botonTextoEn") || s("botonTexto"), href: s("botonHref") || "/tours" },
    decoracion: (s("decoracion") || "ninguna") as Decoracion, colores: { fondo: s("colorFondo") || "#1f9a52", texto: s("colorTexto") || "#ffffff", acento: s("colorAcento") || "#ffc93c" },
    cleto: s("cleto"), cletoAlt: { es: s("cletoAlt"), en: s("cletoAltEn") || s("cletoAlt") }, prioridad: Number(f.prioridad ?? 40), confirmada: !!f.confirmada, nota: f.nota ? s("nota") : undefined, activa: f.activa !== false,
  };
}

/** Al revés: para cargar el calendario base como datos de prueba. */
export function deTemporada(t: Temporada) {
  return {
    clave: t.clave, nombre: t.nombre.es, nombreEn: t.nombre.en, tipo: t.tipo, inicio: new Date(`${t.inicio}T00:00:00.000Z`), fin: new Date(`${t.fin}T00:00:00.000Z`),
    mensaje: t.mensaje.es, mensajeEn: t.mensaje.en, botonTexto: t.boton.es, botonTextoEn: t.boton.en, botonHref: t.boton.href, decoracion: t.decoracion,
    colorFondo: t.colores.fondo, colorTexto: t.colores.texto, colorAcento: t.colores.acento, cleto: t.cleto, cletoAlt: t.cletoAlt.es, cletoAltEn: t.cletoAlt.en,
    prioridad: t.prioridad, confirmada: t.confirmada, activa: t.activa, nota: t.nota ?? null,
  };
}
